<template>
    <div v-if="canShow('用户的基础信息') && info">
        <div class="tips"></div>
        <div class="newre-port">
            <img :src="user.url" v-if="user.url" />
            <img src="../../../../../images/user.png" v-else />
        </div>
        <div class="newre-name">{{ user.name ? user.name : (user.nikeName ? user.nikeName : '') }}</div>
        <div class="newre-info" v-if="info.sex || info.age || info.height || info.weigh">
            <div class="use-mess flex flex-x flex-y">
                <p>性别：{{ info.sex == 1 ? '男' : '女' }}</p>
                <div class="line"></div>
                <p v-if="info.age">年龄：{{ info.age }}岁</p>
                <div class="line" v-if="info.age"></div>
                <p>身高：{{ info.height }}cm</p>
                <div class="line"></div>
                <p>体重：{{ info.weight }}kg</p>
                <div class="fat blue" v-if="MBItext(info.bmi) == '偏瘦'">{{ MBItext(info.bmi) }}</div>
                <div class="fat green" v-if="MBItext(info.bmi) == '正常'">{{ MBItext(info.bmi) }}</div>
                <div class="fat" v-if="MBItext(info.bmi) == '偏胖'">{{ MBItext(info.bmi) }}</div>
                <div class="fat orange" v-if="MBItext(info.bmi) == '肥胖'">{{ MBItext(info.bmi) }}</div>
                <div class="fat red" v-if="MBItext(info.bmi) == '重度肥胖'">{{ MBItext(info.bmi) }}</div>
            </div>
        </div>
        <div class="tips"></div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import { moduleMixin, MBItext } from '../helpers';

export default {
    name: 'ReportUserInfo',
    mixins: [moduleMixin],
    computed: {
        ...mapState('report', ['info', 'user'])
    },
    methods: {
        MBItext
    }
};
</script>
<style lang="scss" scoped>
@import './UserInfo.scss';
</style>
